import { render } from "./BtnValidation.vue?vue&type=template&id=96eb1120&scoped=true"
import script from "./BtnValidation.vue?vue&type=script&lang=js"
export * from "./BtnValidation.vue?vue&type=script&lang=js"

import "./BtnValidation.vue?vue&type=style&index=0&id=96eb1120&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sebamoh\\WebstormProjects\\qrscanner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96eb1120"]])

export default __exports__